import { Check, Minus, X } from 'lucide-react'

import { StepTone } from './timelineSteps'

/**
 * A finished step is not automatically a good one — a denial must not wear a tick.
 *
 * Ink rather than white: white on `accent-green` measures 2.93:1, under the 3:1 minimum
 * for a graphical object. Ink-900 clears it on all three fills (5.8:1, 3.8:1, 4.8:1).
 */
export function DoneGlyph({ tone }: { tone?: StepTone }) {
  if (tone === StepTone.DANGER) return <X className="text-ink-900 size-2.5" strokeWidth={3.5} />
  if (tone === StepTone.NEUTRAL) return <Minus className="text-ink-900 size-2.5" strokeWidth={3} />
  return <Check className="text-ink-900 size-2.5" strokeWidth={3} />
}
